import React, { useEffect } from 'react';
import { Modal, Button, message } from 'antd';
import styles from './test-embed-modal.module.css';

interface TestEmbedModalProps {
  isVisible: boolean;
  setIsVisible: (visible: boolean) => void;
  botId: string;
}

export default function TestEmbedModal({
  isVisible,
  setIsVisible,
  botId,
}: TestEmbedModalProps) {
  const embedCode = `<script defer="defer" src="https://assets2022.s3.us-east-1.amazonaws.com/Global/admin/ozone-ai-avatar.js"></script>
<ozone-ai-avatar avatarid="${botId}"></ozone-ai-avatar>`;

  useEffect(() => {
    const script = document.createElement('script');
    script.src =
      'https://assets2022.s3.us-east-1.amazonaws.com/Global/admin/ozone-ai-avatar.js';
    script.defer = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <Modal
      open={isVisible}
      onCancel={() => {
        setIsVisible(false);
      }}
      footer={null}
      centered
      destroyOnClose
      zIndex={1010}
      width={700}
      bodyStyle={{
        height: '600px',
        overflow: 'auto',
        padding: '20px',
      }}
      style={{
        top: '50px',
      }}
      className={styles.modal}
    >
      <div className={styles.modalContent}>
        <div className={styles.avatarContainer}>
          {/*@ts-ignore*/}
          <ozone-ai-avatar avatarid={botId}></ozone-ai-avatar>

          <div className={styles.embedContainer}>
            <h3>Embed Code</h3>
            <div className={styles.embedCode}>{embedCode}</div>
          </div>
        </div>
      </div>
    </Modal>
  );
}
